(function () {
  if (window.liftDependentVariantOptionsLoaded) {
    return;
  }

  window.liftDependentVariantOptionsLoaded = true;

  function injectStyles() {
    if (document.getElementById('lift-dependent-variant-options-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'lift-dependent-variant-options-style';
    style.textContent = [
      '.lift-hidden-variant-option {',
      '  display: none !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function parseVariants(root) {
    var jsonScript = root.querySelector('script[type="application/json"]');

    if (!jsonScript) {
      return [];
    }

    try {
      return JSON.parse(jsonScript.textContent.trim());
    } catch (error) {
      console.warn('LIFT: Could not parse variant JSON.', error);
      return [];
    }
  }

  function getOptionGroups(root) {
    var groups = [];
    var seenNames = [];

    root.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (!input.name || seenNames.indexOf(input.name) !== -1) {
        return;
      }

      seenNames.push(input.name);

      groups.push({
        name: input.name,
        inputs: Array.from(root.querySelectorAll('input[type="radio"][name="' + CSS.escape(input.name) + '"]'))
      });
    });

    return groups;
  }

  function getLabel(root, input) {
    if (!input.id) {
      return null;
    }

    return root.querySelector('label[for="' + CSS.escape(input.id) + '"]');
  }

  function getSelectedValues(groups) {
    return groups.map(function (group) {
      var checkedInput = group.inputs.find(function (input) {
        return input.checked;
      });

      return checkedInput ? checkedInput.value : null;
    });
  }

  function variantMatchesPreviousOptions(variant, selectedValues, optionIndex) {
    for (var i = 0; i < optionIndex; i++) {
      if (selectedValues[i] && variant.options[i] !== selectedValues[i]) {
        return false;
      }
    }

    return true;
  }

  function optionValueExistsForPreviousSelections(variants, selectedValues, optionIndex, optionValue) {
    return variants.some(function (variant) {
      return variantMatchesPreviousOptions(variant, selectedValues, optionIndex) &&
        variant.options[optionIndex] === optionValue;
    });
  }

  function setElementHidden(element, shouldHide) {
    if (!element) {
      return;
    }

    if (shouldHide) {
      if (!element.classList.contains('lift-hidden-variant-option')) {
        element.classList.add('lift-hidden-variant-option');
      }

      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('tabindex', '-1');
    } else {
      element.classList.remove('lift-hidden-variant-option');
      element.removeAttribute('aria-hidden');
      element.removeAttribute('tabindex');
    }
  }

  function triggerChange(input) {
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateVariantOptions(root) {
    var variants = root.liftVariants || parseVariants(root);
    var groups = root.liftOptionGroups || getOptionGroups(root);

    root.liftVariants = variants;
    root.liftOptionGroups = groups;

    if (!variants.length || groups.length < 2) {
      return;
    }

    for (var optionIndex = 1; optionIndex < groups.length; optionIndex++) {
      var selectedValues = getSelectedValues(groups);
      var group = groups[optionIndex];

      group.inputs.forEach(function (input) {
        var label = getLabel(root, input);
        var shouldShow = optionValueExistsForPreviousSelections(
          variants,
          selectedValues,
          optionIndex,
          input.value
        );

        setElementHidden(input, !shouldShow);
        setElementHidden(label, !shouldShow);

        input.setAttribute('data-lift-valid-option', shouldShow ? 'true' : 'false');
      });

      var checkedInput = group.inputs.find(function (input) {
        return input.checked;
      });

      var checkedInputIsValid = checkedInput &&
        checkedInput.getAttribute('data-lift-valid-option') === 'true';

      if (!checkedInputIsValid) {
        var firstValidInput = group.inputs.find(function (input) {
          return input.getAttribute('data-lift-valid-option') === 'true';
        });

        if (firstValidInput) {
          firstValidInput.checked = true;
          triggerChange(firstValidInput);
        }
      }
    }
  }

  function scheduleUpdate(root) {
    if (root.liftUpdateScheduled) {
      return;
    }

    root.liftUpdateScheduled = true;

    requestAnimationFrame(function () {
      root.liftUpdateScheduled = false;

      updateVariantOptions(root);

      setTimeout(function () {
        updateVariantOptions(root);
      }, 40);

      setTimeout(function () {
        updateVariantOptions(root);
      }, 140);
    });
  }

  function initRoot(root) {
    if (!root || root.liftDependentOptionsInitialized) {
      return;
    }

    root.liftDependentOptionsInitialized = true;

    updateVariantOptions(root);

    root.addEventListener('change', function () {
      scheduleUpdate(root);
    });

    var observer = new MutationObserver(function () {
      scheduleUpdate(root);
    });

    observer.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-disabled', 'disabled']
    });
  }

  function initAll(context) {
    injectStyles();

    var scope = context || document;

    scope.querySelectorAll('variant-radios').forEach(function (root) {
      initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();